/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    fullWidth: {
      description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
      type: 'variant',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: { direction: 'row', space: 5 }
    },
    {
      if: { fullWidth: true },
      tokens: { direction: 'column', fieldSpace: 3, space: 3 }
    }
  ],
  tokens: {
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    direction: 'column',
    fieldSpace: 3,
    outlineOffset: 8,
    outlineWidth: 1,
    showIcon: true,
    space: 3
  }
}
export default theme
